import { type PropsWithChildren, useRef, useState } from 'react';
import classNames from 'classnames';
import useOnClickOutside from 'react-cool-onclickoutside';

interface Props {
    className?: string;
}

export const InfoBox = ({ children, className = '' }: PropsWithChildren<Props>) => {
    const [open, setOpen] = useState(false);
    const [clicked, setClicked] = useState(false);
    const ref = useRef();

    useOnClickOutside(
        (): void => {
            setOpen(false);
            setClicked(false);
        },
        {
            refs: [ref],
            disabled: !clicked,
        },
    );

    return (
        <div className={`info-box u-ml16 flex ${className}`} ref={ref}>
            <span
                className="icon icon--info-mini clickable"
                style={{ width: '25px', height: '25px', minWidth: '25px' }}
                onClick={() => setClicked(true)}
                onMouseOver={() => setOpen(true)}
                onMouseLeave={() => setOpen(clicked)}
            />
            <div className={classNames('info info--left u-d1', { open: open })}>{children}</div>
        </div>
    );
};
